export const A3INNUVA_INTEGRATION_ID = '148642324'
export const DATEV_API_INTEGRATION_ID = '148440300'
export const DATEV_LAUDS_INTEGRATION_ID = 'aoNL4KHjS0CDRdbtSQ1RjQ'
export const INDEED_INTEGRATION_ID = '146407226'
export const INFOJOBS_INTEGRATION_ID = 'HFe_bGxySDWQtY_kGL3cbw'
export const WELCOME_TO_THE_JUNGLE_ID = 'Zv55pUKKQxy0BDgav9aBbQ'
export const BIT_TECHNOLOGIES_ORACLE_NET_SUITE_ID = 'TIcEM9PmQ2GVpHzIdOp4HA'
export const ACICATECH_BUSINESS_CENTRAL_ID = 'cZly3nzXStqYaXzTJ3i6rg'
export const SAGE200_GMINTEGRA_ID = '146471091'
export const DATEV_LUG_API_INTEGRATION_ID = '177166166'
export const DATEV_FACTORIAL_INTEGRATION_ID = 'aoNL4KHjS0CDRdbtSQ1RjQ'
export const MILENA_ILLUSION_INTEGRATION_ID = 'efd0wxwNStWCGvCqIReOdg'
export const SUPREMA_XIPTIC_INTEGRATION_ID = '144394392'
export const SILAE_FORTIFY_INTEGRATION_ID = 'Y0h_Sh7pRxCWpl0DySn_uQ'
export const WHATSAPP_INTEGRATION_ID = '147083486'
export const IDEALDISC_INTEGRATION_ID = '147083451'
export const ZKTECO_ZKTECO_INTEGRATION_ID = '146471263'
